import { IonCard, IonCardContent, IonContent, IonFab, IonFabButton, IonIcon, IonPage, useIonViewDidEnter } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './GaleriaFoco.css';

const GaleriaFoco: React.FC = () => {

  const location = useLocation();
  const history = useHistory();
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {
        setEsconderMenu(true);
  });

  return (
    <IonPage>
      <div id="galeriaFocoFab" style={{ paddingTop: '100px', "background": "#ffffff" }} >
        <IonFab slot="fixed" vertical="top" horizontal="start" style={{ paddingTop: '40px' }}><IonFabButton size='small' onClick={() => history.goBack()}><IonIcon color='primary' icon={arrowBack}></IonIcon></IonFabButton></IonFab>
      </div>
      <IonContent>
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '20px', paddingBottom: '50px' }}>
          <div id='containerGaleriaFoco' style={{ maxWidth: '1024px' }}>
            <IonCard>
              <img src={location.state ? (location.state as { url: string, titulo: string }).url : ""}></img>
              <IonCardContent><h3>{location.state ? (location.state as { url: string, titulo: string }).titulo : ""}</h3></IonCardContent>
            </IonCard>
          </div>
        </div>
      </IonContent>

    </IonPage >
  );

};

export default GaleriaFoco;
